"use client";

import { Plus } from "lucide-react";
import { TreeNode } from "./TreeNode";
import { TreeItem, TreeConfig, FormState, Section } from "../types";

interface TreeSectionProps {
  formState: FormState;
  treeConfig: TreeConfig;
  onNewItem: () => void;
  onToggleExpand: (id: string) => void;
  onEdit: (item: TreeItem) => void;
  onDelete: (item: TreeItem, callback: (updatedSection: Section) => void) => void;
  onSaveCallback: (updatedSection: Section) => void;
}

export const TreeSection = ({
  formState,
  treeConfig,
  onNewItem,
  onToggleExpand,
  onEdit,
  onDelete,
  onSaveCallback,
}: TreeSectionProps) => {
  const idField = treeConfig.fieldMappings.id;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold flex items-center gap-2">
          <span>{treeConfig.treeIcon}</span> {treeConfig.treeTitle}
        </h3>
        <button
          onClick={onNewItem}
          className="flex items-center gap-1 text-sm px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-3.5 h-3.5" />
          {treeConfig.formLabels.newButton}
        </button>
      </div>

      <div className="bg-gray-50 rounded-lg border border-gray-200 p-2 max-h-64 overflow-y-auto">
        {formState.treeItems.length > 0 ? (
          <div className="space-y-0.5">
            {formState.treeItems.map((item, index) => {
              const itemId = item[idField];
              return (
                <div key={itemId || `item-${index}`}>
                  <TreeNode
                    item={item}
                    level={0}
                    treeConfig={treeConfig}
                    expandedIds={formState.expandedIds}
                    editingItemId={formState.editingItemId}
                    onToggleExpand={onToggleExpand}
                    onEdit={onEdit}
                    onDelete={(item) => onDelete(item, onSaveCallback)}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500 text-sm">
            {treeConfig.emptyMessage}
          </div>
        )}
      </div>
    </div>
  );
};

